import { SET_GUEST, RESET, SET_GROUPS } from 'action-creators/travelArrangerGuest';
import { Guest } from 'services/userGuestService';
import { Group } from 'models/group';

export interface TravelArrangerGuestState {
  guest: Guest;
  groups: Group[];
  loading: boolean;
}

const initialState: TravelArrangerGuestState = {
  guest: {
    name: '',
    lastName: '',
    phoneNumber: '',
    country: '',
    birthDate: '',
    email: '',
    gender: 'Male',
    documentNumber: '',
    passportNumber: '',
    userGroupId: '',
  },
  groups: [],
  loading: false
  

};

const reducer = (state = initialState, action): TravelArrangerGuestState => {
  switch (action.type) {
    case SET_GUEST: {
      return {
        ...state,
        guest: action.payload,
      };
    }
    case SET_GROUPS: {
      return {
        ...state,
        groups: action.payload,
        loading:true
      };
    }
    case RESET: {
      return initialState;
    }

    default:
      return state;
  }
};

export default reducer;
